import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { IOrganization } from '@/api/routes/orgs/types';

import { fetchOrgs } from './actionCreators';

interface InitialState {
  orgs: IOrganization[],
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  orgs: [],
  isLoading: false,
  error: '',
};

export const orgsSlice = createSlice({
  name: 'orgs',
  initialState,
  reducers: {
    removeOrg: (state, action: PayloadAction<string>) => {
      const deletedId = action.payload;
      state.orgs = state.orgs.filter((orgs) => orgs.id !== deletedId);
    },
  },
  extraReducers: {
    [fetchOrgs.fulfilled.type]: (state, action: PayloadAction<IOrganization[]>) => {
      state.isLoading = false;
      state.error = '';
      state.orgs = action.payload;
    },
    [fetchOrgs.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchOrgs.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const { removeOrg } = orgsSlice.actions;
export default orgsSlice.reducer;
